import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import './FlowFormLine.css';
/**
 * A focussable line in a flow form.
 */
const FlowFormLine = (({ clickable = 'focus', children, disabled, type, className, onClick }) => {
    const ref = React.useRef(null);
    function handleClick(ev) {
        var _a, _b;
        if (clickable == 'no')
            return;
        const target = ev.target;
        if (target.classList.contains('flowFocussable'))
            return;
        ev.preventDefault();
        ev.stopPropagation();
        if (clickable.startsWith('focus')) {
            const focussable = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.querySelector('.flowFocussable:not(.sidewayFocus):not(.noClickFocus)');
            focussable === null || focussable === void 0 ? void 0 : focussable.focus();
        }
        else if (clickable == 'clickThrough') {
            const focussable = (_b = ref.current) === null || _b === void 0 ? void 0 : _b.querySelector('.flowFocussable:not(.sidewayFocus)');
            focussable === null || focussable === void 0 ? void 0 : focussable.click();
        }
        onClick === null || onClick === void 0 ? void 0 : onClick();
    }
    return _jsxs("div", { ref: ref, className: `flowFormLine ${disabled ? 'disabled' : 'enabled'}${(clickable != 'no' && !disabled) ? ' clickable' : ''}${clickable == 'focusText' ? ' text' : ''} ${type !== null && type !== void 0 ? type : 'primary'} ${className !== null && className !== void 0 ? className : ''}`, onClick: handleClick, onMouseDown: ev => { if (!ev.target.classList.contains('flowFocussable'))
            ev.preventDefault(); }, children: [children, _jsx("div", { className: `flowFormLineSeparator`, children: _jsx("div", {}) })] });
});
export default FlowFormLine;
